// extracted by mini-css-extract-plugin
export default {"orderHeader":"SettingsProducts_orderHeader__wzH5A","button":"SettingsProducts_button__dTqVk","productsContainer":"SettingsProducts_productsContainer__4e4dP"};